import axios from 'axios'
import { REACT_APP_API } from '../../config';

export async function deleteTaskById(id) {
  const response = await axios.delete(`${REACT_APP_API}/leadtasks/${id}`)
  return response
}